import styled from 'styled-components';

export const TabPanelWrapper = styled.div`
  width: 100%;
`;
export const TabPanelItem = styled.div`
  width: 100%;
`;
